import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import { practices } from '../constants/code';
import Layout from '../components/layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import styles from '../styles/code.module.scss';
import Gitlab from '../public/gitlab.svg';
import Image from 'next/image';

export default function Code() {
  const router = useRouter();
  const { t } = useTranslation('code');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
        <InfoSection title='Code' description='code.description' documentationLink='https://help.icdc.io/code/' lang={router.locale} />
        <section className={styles.store}>
          <div>
            <h2>{t('lifecycle.title')}</h2>
            <p>{t('lifecycle.description')}</p>
          </div>
        <Image src='/code.webp' alt="Code" width={697} height={350} unoptimized loading='lazy' />
        </section>

        <section className={styles.practices}>
          <h2>{t('modern_software.title')}</h2>
          <div className='grid'>
            {
              practices.map((practice, index) => (
                <div key={index}>
                  <div className={styles.icon_container}>
                    <Image src={practice.img} alt="" />
                  </div>
                  <p>{t(practice.value)}</p>
                </div>
              ))
            }
          </div>
        </section>

        <section className={styles.features}>
          <div className={styles.gitlab}>
          <Image src={Gitlab} alt="Gitlab" />
            <h2>{t('gitlab.title')}</h2>
            <p>{t('gitlab.description')}</p>
          </div>
          <h2>{t('features.title')}</h2>
          <div className={styles.features__list}>
            { new Array(3).fill('').map((_, index) => <div key={index}>
              <h3>{t(`features.feature${index + 1}.title`)}</h3>
              <p>{t(`features.feature${index + 1}.description`)}</p>
            </div>
            )}
          </div>
        </section>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['code', 'common']),
  },
});
